import { GET_FAQ_START } from '../../types';

export const get_faqs = (payload) => ({
  type: GET_FAQ_START,
  payload,
});
